import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from '../services/layout.service';
import { PerfilModal } from './perfil-modal';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';

/**
 * Armazón de la aplicación autenticada: barra lateral, barra superior y el
 * área de contenido. Las páginas sin sesión (login, callback) quedan fuera de
 * este armazón.
 */
@Component({
  selector: 'app-shell',
  imports: [PerfilModal, RouterOutlet, Sidebar, Topbar],
  template: `
    <div class="flex h-dvh overflow-hidden bg-gray-100 font-sans text-gray-800 antialiased dark:bg-gray-950 dark:text-gray-200">
      <app-sidebar />
      <div class="flex min-w-0 flex-1 flex-col">
        <app-topbar />
        <main class="relative flex-1 overflow-y-auto">
          <!-- Banda oscura decorativa detrás del encabezado de página (estilo Paces) -->
          <div class="pointer-events-none absolute inset-x-0 top-0 h-44 bg-topbar" aria-hidden="true"></div>
          <div class="page-x relative pt-6 pb-8">
            <router-outlet />
          </div>
        </main>
      </div>

      <app-perfil-modal [abierto]="layout.perfilAbierto()" (cerrar)="layout.perfilAbierto.set(false)" />
    </div>
  `,
})
export class Shell {
  protected readonly layout = inject(LayoutService);
}
